import React from "react";
import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { PersonOutline as PersonIcon, WorkOutline as WorkIcon } from "@mui/icons-material";

interface ContactAdminSectionProps {
  title: string;
  jobTitle: string;
  onTitleChange: (value: string) => void;
  onJobTitleChange: (value: string) => void;
}

const sectionTitleStyle = {
  fontWeight: "bold",
  color: "primary.main",
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 2,
} as const;

const ContactAdminSection: React.FC<ContactAdminSectionProps> = ({
  title,
  jobTitle,
  onTitleChange,
  onJobTitleChange,
}) => (
  <>
    <Typography variant="subtitle1" sx={sectionTitleStyle}>
      <PersonIcon fontSize="small" /> Professional & Admin
    </Typography>
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <FormControl fullWidth size="small" sx={{ bgcolor: "background.paper" }}>
          <InputLabel>Title</InputLabel>
          <Select value={title} label="Title" onChange={(e) => onTitleChange(e.target.value)}>
            <MenuItem value="Mr">Mr</MenuItem>
            <MenuItem value="Mrs">Mrs</MenuItem>
            <MenuItem value="Ms">Ms</MenuItem>
            <MenuItem value="Dr">Dr</MenuItem>
            <MenuItem value="Prof">Prof</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={8}>
        <TextField
          label="Job Title/Role"
          fullWidth
          size="small"
          sx={{ bgcolor: "background.paper" }}
          value={jobTitle}
          onChange={(e) => onJobTitleChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <WorkIcon fontSize="small" color="action" />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Grid>
  </>
);

export default ContactAdminSection;
